<script setup lang="ts">
import ContentAlert from '@components/ui/index&view&widget/ContentAlert.vue';

const contentStore = useContentStore();
const route = useRoute();

const messages = computed(() =>
    contentStore.filteredMessages.filter(m =>
        new RegExp(m.urlPattern || '').test(route.path)
    )
);
const redirect = (url?: string) => {
    if (url) {
        window.open(url, '_blank');
    }
};
onMounted(() => contentStore.loadMessages());
</script>

<template>
    <div class="alerts-container">
        <ContentAlert
            v-for="message in messages"
            :key="message.id"
            :class="{ alert: !!message.url }"
            :message
            @click="redirect(message.url)"
        />
    </div>
</template>

<style lang="scss" scoped>
.alerts-container {
    display: flex;
    flex-direction: column;
    .alert {
        cursor: pointer;
    }
}
</style>
